function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function value(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
import { Button, Input, Picker, Toast, Image } from 'antd-mobile';
import React, { useEffect, useRef, useState } from 'react';
import ProtocolCheck from "../../Login/components/ActivityLogin/check";
import qs from 'query-string';
import { answerQustions, getClueOwnerByProjectId, queryAnswersByXfieldOrActId } from "../../../service/api";
import { formatAnswerObj, getVerifyRoles } from "../../../utils/surveyService";
import { getPrefixCls } from "../../../utils";
import { isAreaPhone, isVerifyCode } from "../../../utils/verify";
import "../style.less";
import { diffEnvLoginByVerify, getCountryCodeList, sendVerifyCode } from "../../../service/login";
import { sensorsTrack } from "../../../service/sensors";
var prefixCls = getPrefixCls('SmForm');
var Questionnaire = function Questionnaire(props) {
  var _userInfo$userInfo;
  var questionList = props.questionList,
    QuestionnaireItem = props.QuestionnaireItem,
    accessToken = props.accessToken,
    needPhoneBind = props.needPhoneBind,
    _props$productInfo = props.productInfo,
    productInfo = _props$productInfo === void 0 ? {} : _props$productInfo,
    form = props.form,
    userInfo = props.userInfo,
    id = props.id;
  var activity = productInfo.activity;
  var _ref = activity || {},
    isDelete = _ref.isDelete,
    bottomBanner = _ref.bottomBanner,
    bottomBannerLink = _ref.bottomBannerLink,
    topBanner = _ref.topBanner,
    topBannerLink = _ref.topBannerLink,
    name = _ref.name,
    activityStatus = _ref.activityStatus,
    showConfigExt = _ref.showConfigExt,
    buttonText = _ref.buttonText;
  var _useState = useState(!!showConfigExt && !!JSON.parse(showConfigExt).protocolStatus),
    _useState2 = _slicedToArray(_useState, 2),
    checked = _useState2[0],
    setChecked = _useState2[1];
  var getFieldProps = form.getFieldProps,
    getFieldError = form.getFieldError;
  var senderTimer = null;
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    answersObj = _useState4[0],
    setAnswersObj = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    hadAnswer = _useState6[0],
    setHadAnswer = _useState6[1];
  var _useState7 = useState(['86']),
    _useState8 = _slicedToArray(_useState7, 2),
    areaCode = _useState8[0],
    setAreaCode = _useState8[1];
  var _useState9 = useState(''),
    _useState10 = _slicedToArray(_useState9, 2),
    phone = _useState10[0],
    setPhone = _useState10[1];
  var _useState11 = useState(''),
    _useState12 = _slicedToArray(_useState11, 2),
    verify = _useState12[0],
    setVerify = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    countryCodeList = _useState14[0],
    setCountryCodeList = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    visible = _useState16[0],
    setVisible = _useState16[1];
  var _useState17 = useState(0),
    _useState18 = _slicedToArray(_useState17, 2),
    countdown = _useState18[0],
    setCountdown = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    hassend = _useState20[0],
    setHassend = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    isShowRepeatBuy = _useState22[0],
    setIsShowRepeatBuy = _useState22[1];
  var _useState23 = useState(''),
    _useState24 = _slicedToArray(_useState23, 2),
    weChatUrl = _useState24[0],
    setWeChatUrl = _useState24[1];
  var checkEle = useRef(null);

  /**
   * 获取用户答题记录，若已提交显示‘您已提交’弹层
   */
  var getQuestionAnswers = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _ref3, x_field_1, surveyActivityId, params, questionAnswersRes, _questionAnswersRes$r, questionAnswerList, isAnswer, _formatAnswerObj, _formatAnswerObj2, _answersObj, _hadAnswer;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _ref3 = qs.parse(location.search) || {}, x_field_1 = _ref3.x_field_1, surveyActivityId = _ref3.surveyActivityId;
            params = surveyActivityId ? {
              activityId: surveyActivityId
            } : {
              x_field: x_field_1
            }; // 获取答题信息
            _context.next = 4;
            return queryAnswersByXfieldOrActId(params);
          case 4:
            questionAnswersRes = _context.sent;
            if (!questionAnswersRes.status && !!questionAnswersRes.result) {
              _questionAnswersRes$r = questionAnswersRes.result, questionAnswerList = _questionAnswersRes$r.questionAnswerList, isAnswer = _questionAnswersRes$r.isAnswer;
              _formatAnswerObj = formatAnswerObj(questionAnswerList), _formatAnswerObj2 = _slicedToArray(_formatAnswerObj, 2), _answersObj = _formatAnswerObj2[0], _hadAnswer = _formatAnswerObj2[1];
              setAnswersObj(_answersObj);
              setHadAnswer(_hadAnswer);
            }
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getQuestionAnswers() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleGointoSuccessPage = function handleGointoSuccessPage() {
    var _ref4 = qs.parse(location.search) || {},
      x_field_1 = _ref4.x_field_1,
      orderToken = _ref4.orderToken,
      promotionUserId = _ref4.promotionUserId,
      promotionUserType = _ref4.promotionUserType,
      sourceType = _ref4.sourceType,
      mkey = _ref4.mkey,
      redirect = _ref4.redirect;
    var id = activity.id;
    if (redirect) {
      if (!window) return;
      window.location.href = redirect;
      return;
    }
    if (id && orderToken) {
      props.customFns.push("/success/".concat(orderToken, "?progress=complete"));
    } else {
      props.customFns.push(qs.stringifyUrl({
        url: '/qasuccess',
        query: {
          surveyActivityId: id,
          x_field_1: x_field_1,
          sourceType: sourceType,
          promotionUserId: promotionUserId,
          promotionUserType: promotionUserType,
          mkey: mkey
        }
      }));
    }
  };
  var closeRepeat = function closeRepeat() {
    setIsShowRepeatBuy(false);
  };
  var handleSave = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(val) {
      var _checkEle$current, _checkEle$current$sha;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!(!accessToken || needPhoneBind)) {
              _context3.next = 5;
              break;
            }
            if (!(!phone || !isAreaPhone(phone, areaCode[0]))) {
              _context3.next = 3;
              break;
            }
            return _context3.abrupt("return", Toast.show("\u8BF7\u8F93\u5165".concat(phone ? '正确的' : '', "\u624B\u673A\u53F7")));
          case 3:
            if (!(!verify || !isVerifyCode(verify))) {
              _context3.next = 5;
              break;
            }
            return _context3.abrupt("return", Toast.show("\u8BF7\u8F93\u5165".concat(verify ? '正确的' : '', "\u9A8C\u8BC1\u7801")));
          case 5:
            if (checked) {
              _context3.next = 7;
              break;
            }
            return _context3.abrupt("return", (_checkEle$current = checkEle.current) === null || _checkEle$current === void 0 ? void 0 : (_checkEle$current$sha = _checkEle$current.shake) === null || _checkEle$current$sha === void 0 ? void 0 : _checkEle$current$sha.call(_checkEle$current));
          case 7:
            form.validateFields(/*#__PURE__*/function () {
              var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(error, values) {
                var _window, _qs$parse, x_field_1, promotionUserId, promotionUserType, sourceType, mkey, isAPP, area, answerList, answerValue, i, params, res, data;
                return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      if (error) {
                        _context2.next = 44;
                        break;
                      }
                      _qs$parse = qs.parse(location.search || ''), x_field_1 = _qs$parse.x_field_1, promotionUserId = _qs$parse.promotionUserId, promotionUserType = _qs$parse.promotionUserType, sourceType = _qs$parse.sourceType, mkey = _qs$parse.mkey, isAPP = _qs$parse.isAPP;
                      sensorsTrack('SCRM_activitydetail_buy_click', _objectSpread({
                        scrm_xField: x_field_1 || '',
                        scrm_activity_way: activity.activityWay,
                        scrm_activity_name: activity.name,
                        scrm_activity_id: activity.id,
                        scrm_plan_name: activity.planName,
                        scrm_plan_id: activity.planId
                      }, isAPP === '1' ? {
                        app_source: 1
                      } : undefined));

                      // 未登录 --- 登录 -> 更新用户信息
                      if (!(!accessToken || needPhoneBind)) {
                        _context2.next = 17;
                        break;
                      }
                      area = areaCode[0] === '86' ? '' : areaCode[0];
                      _context2.prev = 5;
                      _context2.next = 8;
                      return diffEnvLoginByVerify(phone, area, verify, '');
                    case 8:
                      _context2.next = 10;
                      return props.getUserInfo();
                    case 10:
                      _context2.next = 12;
                      return getQuestionAnswers();
                    case 12:
                      _context2.next = 17;
                      break;
                    case 14:
                      _context2.prev = 14;
                      _context2.t0 = _context2["catch"](5);
                      return _context2.abrupt("return", Toast.show({
                        content: _context2.t0,
                        icon: 'fail'
                      }));
                    case 17:
                      if (!(activity.activityState === '已结束')) {
                        _context2.next = 19;
                        break;
                      }
                      return _context2.abrupt("return", Toast.show({
                        content: '活动已结束',
                        icon: 'fail'
                      }));
                    case 19:
                      answerList = [];
                      answerValue = activity.pagingDisplay === 2 && !!((_window = window['browser']) !== null && _window !== void 0 && _window.mobile) ? val : values;
                      for (i in answerValue) {
                        answerList.push({
                          questionName: i,
                          answer: answerValue[i]
                        });
                      }
                      params = {
                        ext: {
                          xField: x_field_1,
                          projectId: activity.projectId,
                          activityId: activity.id,
                          promotionUserId: !!promotionUserId && promotionUserId !== 'null' ? parseInt(promotionUserId) : null,
                          landingPageId: activity.id,
                          promotionUserType: !!promotionUserType && promotionUserType !== 'null' ? promotionUserType : null,
                          mkey: mkey
                        },
                        activityWay: activity.activityWay,
                        sourceType: sourceType ? sourceType : 'scrm',
                        surveyName: activity.survey ? activity.survey.name : '',
                        questionAnswerList: answerList
                      };
                      _context2.next = 25;
                      return answerQustions(params);
                    case 25:
                      res = _context2.sent;
                      if (res.status) {
                        _context2.next = 30;
                        break;
                      }
                      Toast.show({
                        content: '提交成功',
                        icon: 'success',
                        afterClose: function afterClose() {
                          handleGointoSuccessPage();
                        }
                      });
                      _context2.next = 42;
                      break;
                    case 30:
                      if (!(res.status === 1601100012)) {
                        _context2.next = 34;
                        break;
                      }
                      Toast.show({
                        content: res.info,
                        duration: 3000,
                        icon: 'fail',
                        afterClose: function afterClose() {
                          var _window2, _window2$location, _window2$location$rel;
                          (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : (_window2$location$rel = _window2$location.reload) === null || _window2$location$rel === void 0 ? void 0 : _window2$location$rel.call(_window2$location);
                        }
                      });
                      _context2.next = 42;
                      break;
                    case 34:
                      if (!(res.status === 16013213)) {
                        _context2.next = 41;
                        break;
                      }
                      _context2.next = 37;
                      return getClueOwnerByProjectId({
                        projectId: activity.projectId
                      });
                    case 37:
                      data = _context2.sent;
                      if (data.status === 0 && data.result) {
                        setIsShowRepeatBuy(true);
                        setWeChatUrl(data.result.weChatCode);
                      } else {
                        Toast.show({
                          content: res.info,
                          icon: 'fail'
                        });
                      }
                      _context2.next = 42;
                      break;
                    case 41:
                      Toast.show({
                        content: res.info
                      });
                    case 42:
                      _context2.next = 45;
                      break;
                    case 44:
                      Toast.show('请先完成问卷');
                    case 45:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2, null, [[5, 14]]);
              }));
              return function (_x3, _x4) {
                return _ref6.apply(this, arguments);
              };
            }());
          case 8:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function handleSave(_x2) {
      return _ref5.apply(this, arguments);
    };
  }();
  var startCountDown = function startCountDown() {
    setCountdown(60);
    setHassend(true);
    senderTimer = setInterval(function () {
      setCountdown(function (count) {
        if (count > 0) {
          return count - 1;
        }
        clearInterval(senderTimer);
        return 0;
      });
      // if (countdown > 0) {
      //     setCountdown(count => count - 1);
      // } else {
      //     setCountdown(0);
      //     clearInterval(senderTimer);
      // }
    }, 1000);
  };
  var handleSendVerifyCode = function handleSendVerifyCode() {
    var _ref7 = qs.parse(location.search) || {},
      sourceType = _ref7.sourceType,
      promotionUserId = _ref7.promotionUserId,
      mcrmActivityTypeStr = _ref7.mcrmActivityTypeStr,
      promotionUserType = _ref7.promotionUserType,
      mkey = _ref7.mkey;
    // countdown 为零可以发送
    if (!countdown) {
      // 如果手机号有误
      if (!phone || !isAreaPhone(phone, areaCode[0])) {
        Toast.show('请输入正确手机号');
        return;
      }
      var where = {
        previewActionType: 'SURVEY',
        projectId: activity.projectId,
        promotionUserId: !!promotionUserId && promotionUserId !== 'null' ? parseInt(promotionUserId) : null,
        landingPageId: activity.id,
        sourceType: sourceType ? sourceType : 'scrm',
        surveyName: activity.survey ? activity.survey.name : '',
        mcrmActivityTypeStr: mcrmActivityTypeStr ? mcrmActivityTypeStr : null,
        promotionUserType: !!promotionUserType && promotionUserType !== 'null' ? promotionUserType : null,
        mkey: mkey
      };
      sendVerifyCode(phone, areaCode[0], where).then(function (msg) {
        Toast.show(msg);
        startCountDown();
      }).catch(function (e) {
        Toast.show(e);
      });
    }
  };
  useEffect(function () {
    getCountryCodeList().then(function (list) {
      return setCountryCodeList(list);
    });
    getQuestionAnswers();
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    id: id
  }, /*#__PURE__*/React.createElement("div", {
    className: "questionnaire-cont",
    style: {
      flexDirection: !!showConfigExt && showConfigExt.mobilePosition === 1 ? "column-reverse" : "column"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "questionnaire-login"
  },
  // 手机号填写控制
  !accessToken || needPhoneBind ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-form-container")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-form-row")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-form-title")
  }, "\u624B\u673A"), /*#__PURE__*/React.createElement(Picker, {
    title: "\u9009\u62E9\u533A\u53F7",
    columns: [countryCodeList],
    value: areaCode,
    visible: visible,
    onClose: function onClose() {
      setVisible(false);
    },
    onConfirm: function onConfirm(value) {
      return setAreaCode(value);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-login-areacode"),
    onClick: function onClick() {
      return setVisible(true);
    }
  }, "+", areaCode[0], /*#__PURE__*/React.createElement("i", {
    className: "iconfont icondown"
  })), /*#__PURE__*/React.createElement(Input, {
    className: "".concat(prefixCls, "-login-phone"),
    type: "number",
    value: phone,
    placeholder: "\u8BF7\u8F93\u5165\u624B\u673A\u53F7",
    clearable: true,
    maxLength: areaCode[0] === '86' ? 11 : 20,
    onChange: function onChange(value) {
      return setPhone(value);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-form-row")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-form-title")
  }, "\u9A8C\u8BC1\u7801"), /*#__PURE__*/React.createElement(Input, {
    value: verify,
    placeholder: "\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801",
    clearable: true,
    maxLength: 6,
    onChange: function onChange(value) {
      return setVerify(value);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: !countdown ? "".concat(prefixCls, "-login-verifycode") : "".concat(prefixCls, "-login-verifycode ").concat(prefixCls, "-disabled"),
    onClick: handleSendVerifyCode
  }, !countdown ? hassend ? '重新获取' : '获取验证码' : "\u91CD\u65B0\u53D1\u9001 ".concat(countdown)))) : /*#__PURE__*/React.createElement("div", {
    className: "questionnaire-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "questionnaire-item-q"
  }, "\u624B\u673A\uFF1A ", userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$userInfo = userInfo.userInfo) === null || _userInfo$userInfo === void 0 ? void 0 : _userInfo$userInfo.Phone))), /*#__PURE__*/React.createElement("div", {
    className: "questionnaire-list"
  }, questionList.map(function (item, index) {
    var defaultAnswer;
    if (item.defaultAnswer) {
      try {
        defaultAnswer = JSON.parse(item.defaultAnswer);
      } catch (error) {
        defaultAnswer = item.defaultAnswer;
      }
    }
    var initialValue = answersObj[item.name] || defaultAnswer;
    // 未做过 && 有默认值 && 院校专业默认值不完整完整
    if (!hadAnswer && defaultAnswer && (item.bizTypeName === '学校' && !defaultAnswer.school || item.bizTypeName === '学院' && (!defaultAnswer.school || !defaultAnswer.college) || item.bizTypeName === '专业' && (!defaultAnswer.school || !defaultAnswer.college || !defaultAnswer.major))) {
      initialValue = null;
    }
    return /*#__PURE__*/React.createElement(QuestionnaireItem, _extends({
      key: index,
      name: item.name,
      required: !!item.requiredFlag,
      disabled: hadAnswer,
      question: item,
      defaultAnswer: defaultAnswer
    }, getFieldProps(item.name, {
      initialValue: initialValue,
      rules: getVerifyRoles(item)
    }), {
      error: getFieldError(item.name)
    }));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "questionnaire-btns"
  }, (productInfo === null || productInfo === void 0 ? void 0 : productInfo.activityState) === '待开始' ? /*#__PURE__*/React.createElement(Button, {
    className: "my-button",
    color: "primary",
    disabled: true
  }, productInfo === null || productInfo === void 0 ? void 0 : productInfo.activityState) : /*#__PURE__*/React.createElement(React.Fragment, null, !hadAnswer && /*#__PURE__*/React.createElement(ProtocolCheck, {
    onRef: function onRef(e) {
      checkEle.current = e;
    },
    checked: checked,
    onChange: function onChange(newCheck) {
      return setChecked(newCheck);
    }
  }), /*#__PURE__*/React.createElement(Button, {
    className: "".concat(prefixCls, "-my-button"),
    color: "primary",
    onClick: hadAnswer ? handleGointoSuccessPage : handleSave
  }, /*#__PURE__*/React.createElement("span", null, hadAnswer ? '您已提交，点击查看更多' : buttonText ? buttonText : '提 交'))), isShowRepeatBuy ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-repeat-buy-mask")
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-repeat-buy-box")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-repeat-buy")
  }, /*#__PURE__*/React.createElement(Image, {
    src: weChatUrl,
    className: "".concat(prefixCls, "-wechat-url")
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-close-icon"),
    onClick: closeRepeat
  })))) : null));
};
export default Questionnaire;